<template>
  <IonMenu ref="menuRef" type="overlay" content-id="main-content" :swipe-gesture="false">
    <IonHeader>
      <IonToolbar color="white">
        <div class="flex justify-center py-2 h-20">
          <img class="contain" src="@/assets/next-century-logo-color.svg" />
        </div>
      </IonToolbar>
    </IonHeader>
    <IonContent color="menu-blue">
      <IonAccordionGroup multiple @ion-change="onAccordionChange($event)" :value="openedSections">
        <IonAccordion value="home" color="menu-blue">
          <div slot="header" class="bg-blue-900 border-b border-white/30 flex items-center text-xl justify-between p-2">
            <div>
              <i class="icon-home mr-2"></i>
              <span>Home</span>
            </div>
            <div
              class="transition-transform size-6 flex items-center justify-center"
              :class="openedSections.includes('home') ? 'rotate-90' : ''"
            >
              <i class="icon-chevron-right"></i>
            </div>
          </div>
          <div class="bg-blue-900 pl-6" slot="content">
            <MenuLink path="/" icon="icon-globe" text="Dashboard"></MenuLink>
            <MenuLink path="/property-list" icon="icon-property" text="Properties"></MenuLink>
            <MenuLink path="/settings" icon="icon-settings" text="Settings"></MenuLink>
          </div>
        </IonAccordion>
        <IonAccordion value="tools">
          <div slot="header" class="bg-blue-900 border-b border-white/30 flex items-center text-xl justify-between p-2">
            <div>
              <i class="icon-tool mr-2"></i>
              <span>Tools</span>
            </div>
            <div
              class="transition-transform size-6 flex items-center justify-center"
              :class="openedSections.includes('tools') ? 'rotate-90' : ''"
            >
              <i class="icon-chevron-right"></i>
            </div>
          </div>
          <div slot="content" class="bg-blue-900 pl-6">
            <MenuLink path="/direct-connect" icon="icon-cast" text="Direct Connect"></MenuLink>
            <MenuLink path="/barcode-scanner" icon="icon-barcode" text="Barcode Scanner"></MenuLink>
            <MenuLink path="/test-connect" icon="icon-radio" text="Test Connect"></MenuLink>
            <MenuLink path="/replace-device" icon="icon-repeat" text="Replace Device"></MenuLink>
          </div>
        </IonAccordion>
        <IonAccordion value="support">
          <div slot="header" class="bg-blue-900 border-b border-white/30 flex items-center text-xl justify-between p-2">
            <div>
              <i class="icon-headphones mr-2"></i>
              <span>Support</span>
            </div>
            <div
              class="transition-transform size-6 flex items-center justify-center"
              :class="openedSections.includes('support') ? 'rotate-90' : ''"
            >
              <i class="icon-chevron-right"></i>
            </div>
          </div>
          <div slot="content" class="bg-blue-900 pl-6">
            <MenuLink
              path="https://support.nextcenturymeters.com"
              icon="icon-help-circle"
              text="Support Center"
              is-external
            ></MenuLink>
            <MenuLink path="/warranty-lookup" icon="icon-award" text="Warranty Lookup"></MenuLink>
            <MenuLink path="/contact-us" icon="icon-mail" text="Contact Support"></MenuLink>
          </div>
        </IonAccordion>
        <IonAccordion value="superadmin" v-super-admin>
          <div slot="header" class="bg-blue-900 border-b border-white/30 flex items-center text-xl justify-between p-2">
            <div>
              <i class="icon-star mr-2"></i>
              <span>Super Admin</span>
            </div>
            <div
              class="transition-transform size-6 flex items-center justify-center"
              :class="openedSections.includes('superadmin') ? 'rotate-90' : ''"
            >
              <i class="icon-chevron-right"></i>
            </div>
          </div>
          <div slot="content" class="bg-blue-900 pl-6">
            <MenuLink
              path="/admin/masquerade"
              icon="icon-user"
              :text="
                user.surpriseMeEnabled || auth.user?._id === 'shansen@nextcenturymeters.com'
                  ? 'Maskereigh\'d'
                  : 'Masquerade'
              "
            ></MenuLink>
          </div>
        </IonAccordion>
      </IonAccordionGroup>
      <div class="flex justify-center my-5">
        <VersionButton @click="menuRef?.$el?.close()"></VersionButton>
      </div>
    </IonContent>
  </IonMenu>
</template>

<script setup lang="ts">
import { IonAccordion, IonAccordionGroup, IonContent, IonHeader, IonMenu, IonToolbar } from '@ionic/vue';
import { ref, useTemplateRef } from 'vue';
import MenuLink from './MenuLink.vue';
import VersionButton from '../information/VersionButton.vue';
import { useUser } from '@/stores/user.store';
import { useAuth } from '@/stores/auth.store';

const openedSections = ref<string[]>(['home', 'tools', 'support', 'superadmin']);
const menuRef = useTemplateRef('menuRef');
const auth = useAuth();
const user = useUser();

function onAccordionChange(ev: CustomEvent) {
  openedSections.value = ev?.detail?.value || [];
}
</script>

<style scoped>
ion-menu::part(container) {
  box-shadow: 0px 0px 15px 10px rgba(0, 0, 0, 0.2);
}
ion-menu::part(backdrop) {
  opacity: 0.9;
  background: var(--ion-color-dark);
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
}

ion-content {
  --padding-start: 15px;
  --padding-top: 5px;
}
</style>
